var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.computedUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }